import { SegmentedControlAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';

const STATIC_DATASOURCE = [
  {
    id: 1,
    image: '/static/assets/avatars/consultation.svg',
    value: 'schedule-type.consultation',
  },
  {
    id: 2,
    image: '/static/assets/avatars/exams.svg',
    value: 'schedule-type.exam',
  },
];

@Controller({ component: 'main-layout', fragment: 'segmented-control' })
export default class AppointmentsTypeScheduleController extends BaseController {

  @Inject('segmented-control-schedule-type')
    staticSegmentedControlAPI!: SegmentedControlAPI;

  @OnMount({ target: 'form-schedule-type' })
  onUserSegmentedControlMount(): void {
    this.staticSegmentedControlAPI.setData(STATIC_DATASOURCE);
  }
}
